import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import { animateScroll as scroll } from 'react-scroll';
import dayjs from "dayjs";
dayjs.locale("ja");

function Users(props) {
  const { params } = props.match;
  const accountId = parseInt(params.id, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [user, setUser] = React.useState(null);

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - アカウント編集";
    scrollToTop();
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAccount();
  }, [auth.state.token]);

  const fetchAccount = () => {
    request({
      method: "GET",
      url: `admin/accounts/${accountId}`,
    }).then((result) => {
      const account = {
        name: result.data.data.name,
        desc: result.data.data.desc,
        contractType: result.data.data.contract_type,
        fhUser: result.data.data.fh_user,
        fhPassword: result.data.data.fh_password,
        maxWords: result.data.data.max_words,
        maxTweets: result.data.data.max_tweets,
        maxCurrent: result.data.data.max_current,
        maxUsers: result.data.data.max_users,
        maxGroups: result.data.data.max_groups,
        maxWordsOr: result.data.data.max_words_or,
        maxWordsAnd: result.data.data.max_words_and,
        maxWordsNot: result.data.data.max_words_not,
        // Add 2023.03.31 投稿分類
        maxNoiseDicts: result.data.data.max_noise_dicts,
        maxNoiseWords: result.data.data.max_noise_words,
        maxLabelDicts: result.data.data.max_label_dicts,
        maxLabelWords: result.data.data.max_label_words,
        maxLabels: result.data.data.max_labels,
        maxInfos: result.data.data.max_infos,
        maxProcs: result.data.data.max_procs,
        validFrom: result.data.data.valid_from,
        validUntil: result.data.data.valid_until,
        limitRelease: result.data.data.limit_release,
        master: {
          name: result.data.data.master.name,
          email: result.data.data.master.email,
          password: null,
        },
        dtmConfig: {
          dtmNoticeId: result.data.data.dtm_config.notice ? 
            result.data.data.dtm_config.notice.id :
            null,
          locked: result.data.data.dtm_config.locked,
        },
        options: {
          media: result.data.data.options.media,
          // Add 2023.03.31 投稿分類
          analysis: result.data.data.options.analysis,
        },
        limitExceed: {
          enable: result.data.data.limit_exceed.enable,
          remain: result.data.data.limit_exceed.remain,
        },
      }

      setUser(account);
    });
  }

  const handleSubmit = (user) => {
    request({
      method: "PUT",
      url: `admin/accounts/${accountId}`,
      data: {
        name: user.accountName,
        desc: user.desc,
        contract_type: user.contractType,
        fh_user: user.fhUser,
        fh_password: user.fhPassword,
        max_words: user.maxWords,
        max_tweets: user.maxTweets,
        max_current: user.maxCurrent,
        max_users: user.maxUsers,
        max_groups: user.maxGroups,
        max_words_or: user.maxWordsOr,
        max_words_and: user.maxWordsAnd,
        max_words_not: user.maxWordsNot,
        // Add 2023.03.31 投稿分類
        max_noise_dicts: user.maxNoiseDicts,
        max_noise_words: user.maxNoiseWords,
        max_label_dicts: user.maxLabelDicts,
        max_label_words: user.maxLabelWords,
        max_labels: user.maxLabels,
        max_infos: user.maxInfos,
        max_procs: user.maxProcs,
        valid_from: user.validFrom,
        valid_until: user.validUntil,
        limit_release: user.limitRelease,
        dtm_config: {
          dtm_notice_id: user.dtmConfig.dtmNoticeId,
          locked: user.dtmConfig.locked,
        },
        options: {
          media: user.options.media,
          // Add 2023.03.31 投稿分類
          analysis: user.options.analysis,
        },
        limit_exceed: {
          enable: user.limitExceed.enable,
          remain: user.limitExceed.remain,
        },
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/account?success=edit");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          user={user}
          isEdit={true}
        />
      }
    />
  );
}
export default withRouter(Users);
